module.exports = __webpack_public_path__ + "static/media/d11ru.838fb904.pdf";